export default __webpack_public_path__ + "static/media/60-memorable-games.67fe420d.txt";